import { Map, AdvancedMarker, APIProvider } from '@vis.gl/react-google-maps'
import env from 'shop/env'
import { useAppContent, useImages, useShop } from 'shop/hooks'
import styled from '@emotion/styled'
import { ImageTagType } from 'shop/types'
import { StoreIcon, StoreMarker } from 'shop/components/Maps/commonStyles'

export const LocationMap = () => {
  const { altLogoImage } = useAppContent()
  const { currentPartnerStore } = useShop()
  const { address: storeAddress, name: storeName } = currentPartnerStore || {}
  const { coordinates } = storeAddress || {}
  const { lat = 0, lng = 0 } = coordinates || {}

  const { getImage } = useImages(
    [{ imageUrl: altLogoImage }],
    ImageTagType.Standard
  )

  const defaultCenter = {
    lat: coordinates?.lat || env.DEFAULT_MAP_CENTER.lat,
    lng: coordinates?.lng || env.DEFAULT_MAP_CENTER.lng
  }

  return (
    <Root data-testid='location-map-root'>
      <APIProvider apiKey={env.MAPS_API_KEY}>
        <Map
          mapId={'4fe2e51066302762793a9398'}
          defaultCenter={defaultCenter}
          center={defaultCenter}
          defaultZoom={15}
          disableDefaultUI={true}
          mapTypeControl={false}
          streetViewControl={false}
          zoomControl={true}
          zoomControlOptions={{
            position: google.maps.ControlPosition.RIGHT_CENTER
          }}
          fullscreenControl={false}
        >
          {coordinates && (
            <AdvancedMarker position={{ lat, lng }}>
              <StoreMarker isClickable={false} size='32px'>
                <StoreIcon src={getImage(50, 50)} alt={storeName || 'store'} />
              </StoreMarker>
            </AdvancedMarker>
          )}
        </Map>
      </APIProvider>
    </Root>
  )
}

const Root = styled.div(() => ({
  width: '100%',
  height: 'inherit'
}))
